import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RegistrierungDatenMTO } from '../generated-model/registrierungDatenMTO';
import { OsmResponse } from '../generated-model/osmResponse';
import { map } from 'rxjs/operators';
import { OsmAdresse } from '../generated-model/osmAdresse';
import { ZugangsdatenMTO } from '../generated-model/zugangsdatenMTO';
import { ZugangsdatenGueltigResponse } from '../generated-model/zugangsdatenGueltigResponse';
import { VertragAngelegtResponse } from '../generated-model/vertragAngelegtResponse';
import { LastschriftMTO } from '../generated-model/lastschriftMTO';
import { LastschriftGueltigResponse } from '../generated-model/lastschriftGueltigResponse';
import { MitarbeiterResponse } from '../generated-model/mitarbeiterResponse';
import { MitarbeiterAngelegtResponse } from '../generated-model/mitarbeiterAngelegtResponse';
import { PrueferResponse } from '../generated-model/prueferResponse';
import { PrueferAngelegtResponse } from '../generated-model/prueferAngelegtResponse';
import { SteuernummerGueltigResponse } from '../generated-model/steuernummerGueltigResponse';

@Injectable({
  providedIn: 'root',
})
export class RegistrierungService {
  protected httpClient = inject(HttpClient);

  registrierungsdaten = {} as RegistrierungDatenMTO;
  protected readonly headers: HttpHeaders;

  private readonly urlAdressPruefungBySuchString = `/remote/registrierung/checkAdresseBySuchString`;
  private readonly urlZugangdatenPruefung = `/remote/registrierung/checkZugangsdaten`;
  private readonly urlVertragAnlegen = `/remote/registrierung/createHandwerkerVertrag`;
  private readonly urlMitarbeiterRegistrierung = `/remote/registrierung/createMitarbeiter`;
  private readonly urlLastschriftPruefung = `/remote/registrierung/checkLastschriftDaten`;
  private readonly urlMitarbeiter = `/remote/registrierung/mitarbeiter/{uuid}`;
  private readonly urlPrueferRegistrierung = `/remote/registrierung/createPruefer`;
  private readonly urlPruefer = `/remote/registrierung/pruefer/{uuid}`;
  private readonly urlCheckSteuernummer = `/remote/registrierung/checkSteuernummer`;

  constructor() {
    this.headers = new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8');
  }

  saveRegistrierungsdatenToLocalStorage(): Observable<any> {
    localStorage.setItem('registrierungsdaten', JSON.stringify(this.registrierungsdaten));
    console.log('saved to local storage!');
    return of(true);
  }

  doOSMAdressPruefungBySuchString(suchString: string): Observable<OsmAdresse[]> {
    return this.httpClient
      .post<OsmResponse>(this.urlAdressPruefungBySuchString, suchString, { headers: this.headers })
      .pipe(
        map((response) => {
          if (response.success) {
            const vorschlaege = response.result;
            return vorschlaege || [];
          }
          return [];
        })
      );
  }

  checkZugangsdaten(zugangsdaten: ZugangsdatenMTO | undefined) {
    const payload = JSON.stringify(zugangsdaten);
    const config = { headers: this.headers };
    return this.httpClient.post<ZugangsdatenGueltigResponse>(this.urlZugangdatenPruefung, payload, config).pipe(
      map((response) => {
        return response;
      })
    );
  }

  checkLastschriftdaten(lastschriftdaten: LastschriftMTO | undefined) {
    const payload = JSON.stringify(lastschriftdaten);
    const config = { headers: this.headers };
    return this.httpClient.post<LastschriftGueltigResponse>(this.urlLastschriftPruefung, payload, config).pipe(
      map((response) => {
        return response;
      })
    );
  }

  createVertrag() {
    const payload = JSON.stringify(this.registrierungsdaten);
    const config = { headers: this.headers };
    return this.httpClient.post<VertragAngelegtResponse>(this.urlVertragAnlegen, payload, config).pipe(
      map((response) => {
        return response;
      })
    );
  }

  registriereMitarbeiter() {
    const payload = JSON.stringify(this.registrierungsdaten);
    const config = { headers: this.headers };
    return this.httpClient.post<MitarbeiterAngelegtResponse>(this.urlMitarbeiterRegistrierung, payload, config).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getRegistrierungsDatenMitarbeiter(uuid: string) {
    let url = this.urlMitarbeiter.replace('{uuid}', uuid);
    return this.httpClient.get<MitarbeiterResponse>(url).pipe(
      map((response) => {
        console.log(response);
        return response;
      })
    );
  }

  registrierePruefer() {
    const payload = JSON.stringify(this.registrierungsdaten);
    const config = { headers: this.headers };
    return this.httpClient.post<PrueferAngelegtResponse>(this.urlPrueferRegistrierung, payload, config).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getRegistrierungsDatenPruefer(uuid: string) {
    let url = this.urlPruefer.replace('{uuid}', uuid);
    return this.httpClient.get<PrueferResponse>(url).pipe(
      map((response) => {
        console.log(response);
        return response;
      })
    );
  }

  checkSteuernummerGueltig(steuernummer: string) {
    const config = { headers: this.headers };
    let url = this.urlCheckSteuernummer;
    return this.httpClient.post<SteuernummerGueltigResponse>(url, steuernummer, config).pipe(
      map((response) => {
        console.log(response);
        return response;
      })
    );
  }
}
